import { render, staticRenderFns } from "./SubnavBar.vue?vue&type=template&id=ddb279f8"
import script from "./SubnavBar.vue?vue&type=script&lang=ts"
export * from "./SubnavBar.vue?vue&type=script&lang=ts"
import style0 from "./SubnavBar.vue?vue&type=style&index=0&id=ddb279f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports